import { common } from '@mui/material/colors';

import { neutrals, success } from '@toolbox/style/theme/common/ThemeProvider/colors';

import type { Theme, SxProps } from '@mui/material';

export const toggleButtonSx = (selected: boolean, sx: SxProps<Theme> = []): SxProps<Theme> => {
  return [
    ({ palette, spacing }) => ({
      top: selected ? 1 : 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      color: palette.primary.main,
      background: selected ? success.lighter : common.white,
      padding: spacing(1.5),
      borderColor: neutrals.dark,
      width: '100%',
      borderRadius: 0.4,
      boxShadow: selected ? 'none' : '0 0 20px 0 rgba(0, 0, 0, 0.05)',
      transition: 'all .3s ease',
      '&:hover': {
        color: palette.primary.main,
        background: selected ? success.lighter : neutrals.contrastText,
        boxShadow: selected ? 'none' : '0 2px 10px 0 rgba(0, 0, 0, 0.33)',
        borderRadius: 0.4,
        borderColor: neutrals.dark,
        top: selected ? 1 : -2,
      },
      '&:active': {
        color: palette.primary.main,
        background: selected ? success.lighter : common.white,
        top: selected ? 1 : -2,
        boxShadow: selected ? 'none' : '0 2px 10px 0 rgba(0, 0, 0, 0.33)',
      },
      '&:focus:not(:hover):not(:active)': {
        color: palette.primary.main,
        background: selected ? success.lighter : common.white,
        top: selected ? 1 : -2,
        boxShadow: selected ? 'none' : '0 2px 10px 0 rgba(0, 0, 0, 0.33)',
      },
      '&:focus:not(:active)': {
        outline: 'none',
      },
    }),
    ...(Array.isArray(sx) ? sx : [sx]),
  ];
};

export const checkboxSx = (sx: SxProps<Theme> = []): SxProps<Theme> => [
  { position: 'absolute', top: 0, right: 0 },
  ...(Array.isArray(sx) ? sx : [sx]),
];
